module.exports = __webpack_public_path__ + "img/collegepubenvhealth-v-474x632.25f31698.jpg";